// hooks/useCountBump.js
import { useEffect, useRef, useState } from "react";

export default function useCountBump(count) {
  const [bump, setBump] = useState(false);
  const prev = useRef(count);

  useEffect(() => {
    if (typeof prev.current === "number" && count > prev.current) {
      setBump(true);
      const t = setTimeout(() => setBump(false), 600); // durée anim
      return () => clearTimeout(t);
    }
    prev.current = count;
  }, [count]);

  // MàJ du prev quand pas d’augmentation (évite double anim)
  useEffect(() => {
    prev.current = count;
  }, [count]);

  return bump; // true pendant ~600ms après une augmentation
}
